export enum TimeFilterTitleEnum {
    All = 'All',
    OnlineNow = 'Online Now',
    LessThan30Mins = '< 30 mins',
    LessThan1Hr = '< 1 hr',
    LessThan8Hrs = '< 8 hrs',
    LessThan24Hrs = '< 24 hrs',
    LessThan72Hrs = '< 72 hrs (3 days)',
    LessThan120Hrs = '< 120 hrs (5 days)',
    LessThan168Hrs = '< 168 hrs (7 days)',
    MoreThan168Hrs = '> 168 hrs',
    Never = 'Never'
}
